<template>
    <div>
        <h1>隐私政策</h1>
    
    </div>
</template>
<script>
export default {
    name:"privacy",
    data(){
        return{
  
        }
    },
    methods:{
    }
}
</script>
<style scoped>

</style>